<template functional>
  <div class="shop-funds-panel__wrapper">
    <img
      :src="require('@/assets/images/homeIcon/' + $options.bg(props.type).img)"
      :style="{ backgroundColor: $options.bg(props.type).color }"
    />
    <div>
      <div class="header-title">
        {{ $options.bg(props.type).name }}
      </div>
      <div class="body-data">
        <span>{{ props.data }}</span>
        <span>元</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopFundsPanel',
  props: ['type', 'data'],
  bg(type) {
    switch (type) {
      case '1':
        return { color: '#005bff', img: 'bg-wait-goods.png', name: '账户余额' };
      case '2':
        return { color: '#00bd83', img: 'bg-wait.png', name: '提现申请中' };
      case '3':
        return { color: '#00aaff', img: 'bg-wait-vertify.png', name: '未入账金额' };
      case '4':
        return { color: '#ff6653', img: 'bg-wait-openshop.png', name: '可提现金额' };
      default:
        return {};
    }
  }
};
</script>

<style lang="scss">
.shop-funds-panel__wrapper {
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  width: 383px;
  height: 126px;
  box-shadow: 0px 6px 12px 0px rgba(0, 43, 156, 0.3);
  &:not(:last-of-type) {
    margin-right: 20px;
  }
  img {
    height: 100%;
    width: 100%;
  }
  & > div {
    color: white;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 23px 40px 14px;
  }
  .header-title {
    height: 22px;
    line-height: 22px;
    font-size: 16px;
    font-weight: 500;
  }
  .body-data {
    margin-top: 34px;
    height: 33px;
    line-height: 33px;
    font-size: 24px;
    font-weight: 500;
    span:last-child {
      margin-left: 16px;
      opacity: 0.5;
      font-size: 14px;
      font-weight: normal;
    }
  }
}
</style>
